/**
 * Constantes tuiles cartographiques — Géoplateforme IGN (WMTS).
 * Mêmes sources que BonUrba : accès libre, pas de clé API, tuiles pré-cachées.
 */

const IGN_WMTS =
  'https://data.geopf.fr/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0' +
  '&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/png' +
  '&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}'

/** Plan IGN v2 — inclut le cadastre aux zooms élevés (>= 16). */
export const IGN_PLAN_URL = `${IGN_WMTS}&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2`

/** Orthophotos IGN (satellite). */
export const IGN_SATELLITE_URL = IGN_WMTS.replace('image/png', 'image/jpeg') +
  '&LAYER=ORTHOIMAGERY.ORTHOPHOTOS'

/** Parcellaire cadastral (overlay transparent). */
export const IGN_CADASTRE_URL = `${IGN_WMTS}&LAYER=CADASTRALPARCELS.PARCELLAIRE_EXPRESS`

export const IGN_ATTRIBUTION = '&copy; <a href="https://geoservices.ign.fr/">IGN</a>'
